import React from 'react';
import {Icon, Modal, Pagination, Tooltip} from 'antd';
import { FileType } from '../../APIModels/FileParam';
import { formatDate } from "../../util/UtilFunction";
import { PageSizeOptionsString } from '../../APIModels/BaseParams';

export class FMKEditionsTable extends React.Component {

    constructor(props) {
        super(props)

        this.showSizeChange = this.showSizeChange.bind(this);
        this.pageChange = this.pageChange.bind(this);
    }

    goToDetail(id) {
        window.open("/archive/edition/detail?id=" + id, "_self")
    }

    goToEdit(id) {
        window.open("/archive/edition/edit?id=" + id, "_self")
    }

    goToArticles(id) {
        window.open("/archive/articles?editionId=" + id, "_self")
    }

    downloadPdf(id) {
        let edition = this.props.editions.filter(e => e.id == id)[0];
        let pdfComplete = edition.files.filter(f => f.type == FileType.CompletePdf)[0];
        this.props.downloadFile(pdfComplete.id, pdfComplete.fileName, 'application/pdf')
    }

    downloadTxt(id) {
        let edition = this.props.editions.filter(e => e.id == id)[0];
        let txtComplete = edition.files.filter(f => f.type == FileType.CompleteTxt)[0];
        this.props.downloadFile(txtComplete.id, txtComplete.fileName, 'text/plain')
    }

    showModal(id, name) {
        this.props.setModal(true, name, id)
    }

    handleOk(id) {
        this.props.setModal(false, '', null)
        this.props.deleteEdition(id)
    }

    handleCancel() {
        this.props.setModal(false, '', null)
    }

    showSizeChange(current, size) {
        this.props.setPagination(size, current)
    }

    pageChange(page, size) {
        this.props.setPagination(size, page)
    }

    render() {

        let modal =
            <Modal title="Delete edition" visible={this.props.modalOpen} onOk={() => this.handleOk(this.props.modalId)} onCancel={() => this.handleCancel()}>
                <p>Delete edition <strong>{this.props.modalTitle}</strong> and all articles related?</p>
            </Modal>

        let thead =
            <tr>
                <th style={{ width: '15%' }}><p style={{ whiteSpace: "nowrap", marginBottom: '0' }}>Magazine</p></th>
                <th style={{ width: '10%' }}><p style={{ whiteSpace: "nowrap", marginBottom: '0' }}>Date</p></th>
                <th style={{ width: '2%' }}>Number</th>
                <th style={{ width: '40%' }}>Description</th>
                <th style={{ width: '10%' }}>Date last change</th>
                <th style={{ width: '17%' }}>File</th>
                <th style={{ width: '6%' }}></th>
            </tr>

        return (
            <div className="tableContainer">
                {this.props.editions && this.props.editions.length > 0 ? (
                    //Table
                    <div>
                        <table className='table table-striped fmk_table my-4'>
                            <thead>
                                {thead}
                            </thead>
                            <tbody>
                                {
                                    this.props.editions.map(edition => {
                                        return (
                                            <tr key={edition.id}>
                                                <td onClick={() => this.goToDetail(edition.id)}>{edition.magazine.name}</td>
                                                <td onClick={() => this.goToDetail(edition.id)}>{formatDate(edition.competenceDateFrom, 'MMMM YYYY')}</td>
                                                <td onClick={() => this.goToDetail(edition.id)}>
                                                    <div className="fmk_link">
                                                        {edition.number}
                                                    </div>
                                                </td>
                                                <td onClick={() => this.goToDetail(edition.id)}>{edition.description}</td>
                                                <td onClick={() => this.goToDetail(edition.id)}>{formatDate(edition.lastUpdate)}</td>
                                                <td>
                                                    <span
                                                        className={"fmk_link " + (edition.files.filter(f => f.type == FileType.CompletePdf).length == 0 ? "iconDisabled" : "")}
                                                        onClick={() => this.downloadPdf(edition.id)}>
                                                        download pdf
                                                    </span>
                                                    <span className="fmk_link iconDisabled mx-1">-</span>
                                                    <span
                                                        className={"fmk_link " + (edition.files.filter(f => f.type == FileType.CompleteTxt).length == 0 ? "iconDisabled" : "")}
                                                        onClick={() => this.downloadTxt(edition.id)}>
                                                        download txt
                                                    </span>
                                                </td>
                                                <td style={{fontSize: 18}}>
                                                    <Tooltip placement="topLeft" title="Edit" arrowPointAtCenter>
                                                        <Icon type="edit" className="mx-2" onClick={() => this.goToEdit(edition.id)}/>
                                                    </Tooltip>

                                                    <Tooltip placement="topLeft" title="Delete" arrowPointAtCenter>
                                                        <Icon type="delete" onClick={() => this.showModal(edition.id, edition.number)}/>
                                                    </Tooltip>
                                                </td>
                                            </tr>
                                        )
                                    })
                                }
                            </tbody>
                        </table>
                        <Pagination className="FMKPagination mb-4" showSizeChanger hideOnSinglePage pageSizeOptions={PageSizeOptionsString} onChange={this.pageChange} onShowSizeChange={this.showSizeChange} size="small" total={this.props.paramResponse.totalItems} />
                    </div>
                ) : (
                    //NothingFound
                        <h3 className="text-center">{this.props.fetchFinish ? 'Nothing found' : '' }</h3>
                )}

                {modal}
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/FileMaker/Editions/FMKEditionsTable.js